import React from 'react';
import { createRoot } from 'react-dom/client';
import App from "./components/App.js";
import "./components/css/App.css";
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const mapjs = (
  <div>
    <App />
  </div>
);

const container = document.getElementById('app');
const root = createRoot(container);
root.render(mapjs);